(function () {
  function initialise(root) {
    root.querySelectorAll('[data-preorder-countdown]').forEach(function (section) {
      if (section.dataset.initialised) return;
      section.dataset.initialised = 'true';
      var raw = section.dataset.opensAt || '';
      var target = /T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
      if (!Number.isFinite(target)) return;
      var clock = section.querySelector('[data-countdown-clock]');
      var status = section.querySelector('[data-countdown-status]');
      status.hidden = true;
      var timer;
      function tick() {
        if (!section.isConnected) { clearInterval(timer); return; }
        var seconds = Math.max(0, Math.ceil((target - Date.now()) / 1000));
        var days = Math.floor(seconds / 86400);
        section.querySelector('[data-countdown-days]').textContent = String(days).padStart(2, '0');
        section.querySelector('[data-countdown-hours]').textContent = String(Math.floor(seconds % 86400 / 3600)).padStart(2, '0');
        section.querySelector('[data-countdown-minutes]').textContent = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
        section.querySelector('[data-countdown-seconds]').textContent = String(seconds % 60).padStart(2, '0');
        clock.hidden = false;
        if (!seconds) {
          status.textContent = 'The opening is approaching. Sign up for the announcement.';
          status.hidden = false;
          clearInterval(timer);
        }
      }
      timer = setInterval(tick, 1000);
      tick();
    });
    root.querySelectorAll('[data-prelaunch-product="true"]').forEach(function (form) {
      if (form.dataset.interestReady) return;
      form.dataset.interestReady = 'true';
      var select = form.querySelector('[data-interest-variant]');
      if (!select) return;
      function sync() {
        var id = form.querySelector('[name="id"]').value;
        var option = Array.from(select.options).find(function (option) { return option.dataset.variantId === id; });
        if (option) select.value = option.value;
      }
      form.querySelectorAll('[data-option-selector]').forEach(function (control) {
        control.addEventListener('click', sync);
        control.addEventListener('change', sync);
      });
      select.addEventListener('change', function () {
        var dataElement = document.querySelector('[data-nowar-product-json]');
        if (!dataElement) return;
        var data = JSON.parse(dataElement.textContent);
        var selected = select.selectedOptions[0].dataset.variantId;
        var variant = data.variants.find(function (v) { return String(v.id) === selected; });
        if (!variant) return;
        variant.options.forEach(function (value, index) {
          var control = Array.from(form.querySelectorAll('[data-option-selector]')).find(function (el) { return Number(el.dataset.optionIndex) === index && el.dataset.value === value; });
          if (control) control.click();
        });
        sync();
      });
      sync();
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
